module.exports = __webpack_public_path__ + "img/Layer_1.b66efdd9.svg";